import { SET_ORDERS_HISTORY, SET_ORDER_RATING } from './constants';

const initialState = {
  list: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDERS_HISTORY:
      return {
        ...state,
        list: action.payload,
      };
    // Patches the one order that was rated rather than refetching the history.
    // `rating` is null when a customer removes theirs, which is what puts the
    // blank form back in front of them.
    case SET_ORDER_RATING:
      return {
        ...state,
        list: (state.list || []).map(order => (
          order.id === action.payload.orderId
            ? { ...order, rating: action.payload.rating }
            : order
        )),
      };
    default:
      return state;
  }
};

export default reducer;
